var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1209_68)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1209_68)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.0001,
    cy: 15.0001,
    r: 13.9583,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.625 9C11.4583 10.5278 10.4861 11.8333 10.4861 11.9167C10.4861 12 10.9861 12.0833 11.5972 12.0833H12.7083V14.1667V16.25H14.9305H17.1528V14.1667V12.0833H18.2639C18.875 12.0833 19.375 12 19.375 11.9167C19.375 11.6944 15.0972 6.25 14.9305 6.25C14.8472 6.25 13.8194 7.5 12.625 9ZM16.2916 9.5C17.4305 10.9444 17.4305 10.9722 16.7639 10.9722C16.0972 10.9722 16.0694 11.0278 15.9861 13.1111L15.9028 15.2778H14.9305H13.9583L13.875 13.1111C13.7916 11.0556 13.7639 10.9722 13.125 10.9722C12.4583 10.9722 12.4583 10.9444 13.625 9.44444C14.2639 8.61111 14.875 7.94444 14.9583 8C15.0694 8.02778 15.6528 8.72222 16.2916 9.5Z",
    fill: "#0000FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04175 20.6944V23.75H14.9306H23.8195V20.6944C23.8195 19 23.764 17.6389 23.6806 17.6389C23.6251 17.6389 22.9584 17.8333 22.264 18.0833C21.0417 18.5 20.8195 18.5 19.3473 18.0556C17.8195 17.5833 17.7084 17.5833 16.3473 18.0833C14.9862 18.5556 14.8751 18.5556 13.514 18.0833C12.1529 17.5833 12.0417 17.5833 10.514 18.0556C9.04175 18.5 8.81953 18.5 7.5973 18.0833C6.90286 17.8333 6.23619 17.6389 6.18064 17.6389C6.0973 17.6389 6.04175 19 6.04175 20.6944ZM13.5695 19.1944C14.6806 19.5833 14.9306 19.5833 16.3751 19.1389C17.8751 18.6944 18.0695 18.6944 19.4306 19.1389C20.514 19.4722 21.1529 19.5278 21.8195 19.3333C22.5973 19.1111 22.7084 19.1389 22.7084 19.5833C22.7084 20.2222 21.1806 20.5833 19.9862 20.2778C19.5695 20.1667 18.6529 20.0833 17.9306 20.0833C17.1806 20.1111 15.8473 20.1389 14.9306 20.1389C14.014 20.1389 12.6806 20.1111 11.9584 20.0833C11.2084 20.0833 10.2917 20.1667 9.87508 20.2778C8.68064 20.5833 7.15286 20.2222 7.15286 19.5833C7.15286 19.1389 7.26397 19.1111 8.0973 19.3333C8.76397 19.5278 9.3473 19.4722 10.0973 19.1944C11.5695 18.6667 12.1529 18.6667 13.5695 19.1944ZM14.9306 21.3056C17.7362 21.25 19.5973 21.25 21.1251 21.3056C22.5695 21.3611 22.7084 21.4167 22.7084 22V22.6389H14.9306H7.15286V21.9444C7.15286 21.3056 7.20841 21.2778 8.51397 21.4444C9.31953 21.5278 10.0695 21.4722 10.3751 21.2778C10.7084 21.0833 11.4306 21.0278 12.2917 21.1389C13.0695 21.2222 14.2362 21.3056 14.9306 21.3056Z",
    fill: "#0000FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1209_68",
    x: -0.958252,
    y: -0.958252,
    width: 31.9167,
    height: 31.9167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1209_68"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1209_68",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1209_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTide);
export default __webpack_public_path__ + "static/media/tide.c47c85faf60ab6d5987c845a260f3a0b.svg";
export { ForwardRef as ReactComponent };